export class HorseSubClass {
    id: string = '';
    name: string = '';
    status: number = null;
    tooltip: string = null;
}
